import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import { StatisticsInner } from './StatisticsInner/StatisticsInner';
import styles from './styles.module.scss';

export type StatisticsProps = SliceComponentProps<Content.StatisticsSlice>;

const Statistics = ({ slice }: StatisticsProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={styles.section}
      id={slice.id}
    >
      <StatisticsInner data={slice.primary} />
    </section>
  );
};

export default Statistics;
